"use client";

import { useMarket } from "@app/_context";
import { useMemo } from "react";

// Derive the correct return type from Intl.PluralRules directly
type PluralKey = ReturnType<Intl.PluralRules["select"]>;

export function usePluralizedTranslation() {
  const market = useMarket().state.market;

  // Memoize to avoid recreating rules unnecessarily
  const pluralRules = useMemo(
    () =>
      new Intl.PluralRules(market.contentfulLocale, {
        type: "cardinal",
      }),
    [market.contentfulLocale],
  );

  /**
   * Returns the correct singular or plural translation based on the count.
   * @param count - The number to evaluate
   * @param singular - Singular form (e.g. "product")
   * @param plural - Plural form (e.g. "products")
   */
  function pluralize(count: number, singular: string, plural: string) {
    const form: PluralKey = pluralRules.select(count);
    return form === "one" ? singular.toLowerCase() : plural.toLowerCase();
  }

  return pluralize;
}
